<template>
	<Alert v-if="!noFollow" class="mb-4 mx-1"/>
	<UiForm
		:id="'login-form_' + elementId + '_' + (noFollow?'-reauth':'')">
		<TextInput v-model="form.email" type="email" :label="trans('users.labels.email')" :name="'email_' + elementId" autocomplete="email" class="mb-2" :disabled="noFollow"/>
		<TextInput v-model="form.password" type="password" :label="trans('users.labels.password')" :name="'password_' + elementId" class="mb-4"/>
		<div class="text-center">
			<UiButton
				v-if="noFollow"
				class="me-2"
				type="button"
				:label="'Cancel' + (globalStateStore.sessionExpired ? ' and Log out' : '')"
				data-bs-dismiss="modal"
				@click="onClose"/>
			<UiButton
				v-if="noFollow"
				type="submit"
				:label="submitLabel"
				data-bs-dismiss="modal"
				@click="onFormSubmit"/>
			<button
				v-else
				type="submit"
				:label="submitLabel"
				class="btn px-3 py-2 border border-transparent text-sm rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 text-center transition "
				@click="onFormSubmit">
				{{ submitLabel }}
			</button>
		</div>
	</UiForm>
</template>

<script lang="ts" setup>
	import { trans } from "@/helpers/i18n";
	import { reactive, ref, computed, defineComponent, onMounted } from "vue";
	import { useAuthStore } from "@/stores/auth";
	import { useGlobalStateStore } from "@/stores/global";
	import UiButton from "@/views/components/input/UiButton.vue";
	import TextInput from "@/views/components/input/TextInput.vue";
	import Alert from "@/views/components/Alert.vue";
	import UiForm from "@/views/components/UiForm.vue";
	import { v4 as uuidv4 } from "uuid";

	const props = withDefaults(defineProps<{
		noFollow?: boolean,
		showLogoutSessions?: boolean,
		elementId?: string
	}>(), {
		noFollow: false,
		showLogoutSessions: false
	});

	const emits = ["error"];
	const authStore = useAuthStore();
	const globalStateStore = useGlobalStateStore();
	const form = reactive({
		email: "",
		password: ""
	});

	const submitLabel = computed (() => {
		if (props.noFollow) return "Submit";
		else return trans("global.buttons.login");
	});
	const c_password = computed (() => {
		return form.password;
	});
	onMounted(() => {
		if (props.noFollow) form.email = authStore.user.email;
	});

	function updateValue (e: Event) {
		form.password = (e.target as HTMLInputElement).value;
	}

	const emit = defineEmits(["clear", "submit", "close"]);
	function onClose () {
		// console.log("CLOSE");
		// log out too if we were here because of a 401
		if (globalStateStore.sessionExpired) {
			globalStateStore.showReLoginModal = false;
			globalStateStore.sessionExpired = false;
			authStore.logout();
		}

		emit("close");
	}
	function onFormSubmit () {
		// console.log("SUBMIT");
		const payload = {
			email: form.email,
			password: form.password
		};

		// log out other sessions
		if (props.showLogoutSessions) authStore.logoutOtherSessions(form.password);
		// reauth session
		else if (props.noFollow) authStore.reauthenticateUser(form.password);
		// just log in
		else authStore.login(payload, props.noFollow);

		emit("submit");
	}

</script>
